import axios from 'axios';
import classnames from 'classnames';
import { useAtomValue } from 'jotai';
import qs from 'qs';
import { useCallback, useEffect, useState } from 'react';
import { SimpleImage } from '@components/common/SimpleImage';
import { UiKitButton } from '@components/common/ui-kit-button';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { Timer } from '@features/Unsubscribe/components/Timer';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import { emailAtom } from '@features/Unsubscribe/steps/EmailEnter';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import styles from './CheckEmail.module.scss';
export const CheckEmail = (props: TpWizardSteps) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const [targetTime, setTargetTime] = useState(59);
  const email = useAtomValue(emailAtom);
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics({
    email
  });
  const onCountdownComplete = useCallback(() => {
    setIsCompleted(true);
  }, []);
  const resendHandler = useCallback(async () => {
    const formData = {
      email
    };
    try {
      await axios({
        method: 'post',
        url: `${process.env.NEXT_PUBLIC_API_MICROSERVICE_ENDPOINT}cancellation_verify_email`,
        data: qs.stringify(formData)
      });
      trackUnsubscribeEvent('cancel_check_email_resend_tapped');
      setIsCompleted(false);
      setTargetTime(Date.now() + 60 * 1000);
    } catch (error) {
      console.log(error);
    }
  }, [email, trackUnsubscribeEvent]);
  useEffect(() => {
    const userDataFromStorage = sessionStorage.getItem('userData');
    const parsedData = userDataFromStorage !== null && JSON.parse(userDataFromStorage);
    const findCurrent = parsedData.find((item: {
      email: string;
      targetTime: number;
    }) => item.email === email && Number(item.targetTime) > Date.now());
    if (findCurrent !== undefined) {
      setTargetTime(Number(findCurrent.targetTime));
    }
  }, [email]);
  return <Container className={styles.container} eventOnMounted="cancel_check_email_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="CheckEmail" data-sentry-source-file="index.tsx">
      <div className={classnames('double-grow', styles.content)}>
        <SimpleImage src="cancelling-check-email.svg" width="129" height="128" alt="check email" data-sentry-element="SimpleImage" data-sentry-source-file="index.tsx" />
        <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">Check your email</Title>

        <p className={styles.description}>
          We’ve sent you an email to {email} with the link to cancel your
          current subscription
        </p>
        <p className={styles.description}>
          If you haven’t received any, please check your spam folder
        </p>
      </div>

      <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
        <UiKitButton color="pure" className={styles.button} disabled={!isCompleted} onClick={resendHandler} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Resend Email{' '}
          {targetTime > Date.now() && <>
              (
              <Timer targetTimeInMs={targetTime} onCountdownComplete={onCountdownComplete} />
              )
            </>}
        </UiKitButton>
      </ButtonGroup>
    </Container>;
};